import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

import { useAttrs, useSlots } from "vue";
import { NSelect, type SelectOption, type SelectGroupOption } from "naive-ui";
import { studioSelectOptions, type StudioFieldOption } from "./studioSelectOptions";
import { studioSelectTheme } from "./studioSelectTheme";
import "../studioSelect.css";


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'StudioSelectField',
  props: {
    modelValue: {},
    value: {},
    disabled: { type: Boolean },
    placeholder: {}
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;
const slots = useSlots();
const attrs = useAttrs();
const menuProps = { class: "studio-select-menu", "data-clip-editor": "" };
// Evaluate the slot during rendering so v-for/v-if options stay reactive.
function selection() {
  const rows = studioSelectOptions(slots.default?.() ?? []);
  const options: (SelectOption | SelectGroupOption)[] = [];
  for (const [index, row] of rows.entries()) {
    const option = { label: row.label, value: index, disabled: row.disabled };
    if (row.group) {
      let group = options.find(item => item.type === "group" && item.label === row.group) as SelectGroupOption | undefined;
      if (!group) { group = { type: "group", key: row.group, label: row.group, children: [] }; options.push(group); }
      (group.children ??= []).push(option);
    } else options.push(option);
  }
  const value = props.modelValue !== undefined ? props.modelValue : props.value;
  const index = rows.findIndex(row => Object.is(row.value, value));
  return { rows, options, value: index < 0 ? null : index };
}
function update(index: number, rows: StudioFieldOption[]) {
  const row = rows[index];
  if (props.disabled || !row || row.disabled) return;
  emit("update:modelValue", row.value as T);
  // Preserve existing @change handlers while v-model receives the original typed value.
  const event = new Event("change");
  const target = { value: String(row.value ?? ""), selectedIndex: index };
  Object.defineProperties(event, { target: { value: target }, currentTarget: { value: target } });
  emit("change", event);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([selection()], (state) => {
    return (_openBlock(), _createBlock(_unref(NSelect), _mergeProps({
      key: 0,
      ref_for: true
    }, _unref(attrs), {
      class: "studio-select-field nodrag nopan",
      value: state.value,
      options: state.options,
      "aria-label": String(_unref(attrs)['aria-label'] ?? __props.placeholder ?? '选择选项'),
      disabled: __props.disabled,
      placeholder: __props.placeholder ?? '请选择',
      "theme-overrides": _unref(studioSelectTheme),
      "menu-props": menuProps,
      "consistent-menu-width": false,
      "onUpdate:value": ($event: any) => (update($event, state.rows))
    }), null, 16, ["value", "options", "aria-label", "disabled", "placeholder", "theme-overrides", "onUpdate:value"]))
  }), 128))
}
}

})